module.exports = __webpack_public_path__ + "static/media/splash-logo.8ab72610.png";